module.exports = __webpack_public_path__ + "img/CM-BS-25-Acura-Lifestyle.cd6b84a5.jpg";